import { UserManagerSettings, WebStorageStateStore } from 'oidc-client';
import { getChatScriptSource } from '../commons/assistente-pessoal/assistente-pessoal.config';
import { getAvaliacoesConfig } from '../commons/avaliacoes/avaliacoes.config';
import { getEvaChatConfig } from '../commons/chat-bot-eva-source/chat-bot-eva-source.config';
import { detectaNavegador } from '../commons/detecta-navegador/detecta-navegador.config';
import { getElegibilidadeAlunoNovaHome } from '../commons/elegibilidade-aluno-nova-home/elegibilidade-aluno-nova-home';
import { getElegibilidadeDashboardDisicplinaConfig } from '../commons/elegibilidade-dashboard-disciplina/elegibilidade-dashboard-disciplina.config';
import { getElegibilidadeExibirNomeTutorDisciplinaConfig } from '../commons/elegibilidade-exibir-nome-tutor-disciplina/elegibilidade-exibir-nome-tutor-disciplina.config';
import { getElegibilidadeSecaoAvaliacoes } from '../commons/elegibilidade-secao-avaliacoes/elegibilidade-secao-avaliacoes.config';
import { getElegibilidadeSuporteAosEstudosConfig } from '../commons/elegibilidade-suporte-aos-estudos/elegibilidade-suporte-aos-estudos.config';
import { elegivelTapumeManutencao } from '../commons/elegibilidade-tapume-manutencao/elegibilidade-tapume-manutencao.config';
import { getElegibilidadeWidgetAvaliacaoConfig } from '../commons/elegibilidade-widget-avaliacao/elegibilidade-widget-avaliacao.config';
import { getFormacaoSociomeocionalConfig } from '../commons/formacao-socioemocional/formacao-socioemocional.config';
import { getChatHelp } from '../commons/menu/chat-help/chat-help.config';
import { getSubMenusDisciplinas } from '../commons/menu/disciplinas/disciplinas.config';
import { getItensMenuConfig } from '../commons/menu/menu.config';
import { paraMsalConfiguration } from '../commons/msal.commons';
import { segmentacaoOcultarMenuAvaliacoesConfig } from '../commons/segmentacao-ocultar-menu-avaliacoes/segmentacao-ocultar-menu-avaliacoes.config';
import { getTapumeAvaliacoesConfig } from '../commons/tapume-avaliacoes/tapume-avaliacoes.config';
import { getTapumeConfig } from '../commons/tapume-erro-carregamento/tapume-erro-carregamento.config';
import { Environment } from '../types';
import {
  AJUDA_LOGIN,
  EMPREGABILIDADE,
  EXTENSOES_VALIDAS_ENVIO_ARQUIVO,
  TESTE_SOCIOCOMPORTAMENTAL,
  tapume,
} from './common';

const buildSettings = (): UserManagerSettings => ({
  authority: 'https://login.microsoftonline.com/da49a844-e2e3-40af-86a6-c3819d704f49/v2.0/',
  client_id: '2417f756-361f-406e-b94a-e6ba01fb7cc8',
  redirect_uri: `${window.location.protocol}//${window.location.host}`,
  post_logout_redirect_uri: `${window.location.protocol}//${window.location.host}`,
  monitorSession: false,
  userStore: new WebStorageStateStore({ store: localStorage }),
  prompt: 'select_account',
  response_type: 'code',
  automaticSilentRenew: true,
  loadUserInfo: false,
  scope: '2417f756-361f-406e-b94a-e6ba01fb7cc8/.default',
});

const hml = (): Environment => {
  const settings: UserManagerSettings = buildSettings();
  const apiUrl = localStorage.getItem('apiUrl');
  const apiV2Url = localStorage.getItem('apiV2Url');
  const urlQc = localStorage.getItem('urlQc');
  const ambiente = 'hml';
  const marca = 'estacio';
  return {
    contextos: [
      { host: 'https://aluno-frontend.estacioqa.net', redirect: 'https://estudante-sava-estacio.estacioqa.net' },
      {
        host: 'https://estudante-aura-estacio.estacioqa.net',
        redirect: 'https://estudante-sava-estacio.estacioqa.net',
      },
      {
        host: 'https://estudante-sava-estacio.estacioqa.net',
        redirect: 'https://estudante.estacio.sava.qld.yduqs.com.br',
      },
      { host: 'https://estudante.estacio.sava.qld.yduqs.com.br' },
    ],
    ambiente,
    marca,
    tapume,
    idClienteEnsineme: 'A39EAE23-8E99-27B8-82FC-D5ABAF8953CD',
    API_DEDICADA: apiUrl ?? 'https://apis.estudante.estacio.sava.qld.yduqs.com.br/rest',
    API: apiUrl ?? 'https://sava-estacio.estacioqa.net/apis',
    API_V2: apiV2Url ?? 'https://hmlapi.estacio.br/homolog/aura-frontend',
    API_TRABALHABILIDADE: apiUrl ?? 'https://apis.estacio.trabalhabilidade.qld.yduqs.com.br/rest',
    URL_QC: urlQc ?? 'https://app-master-lms.qcx-dev.com',
    URL_REDIRECT_ENSINEME: 'https://stecine.azureedge.net/repositorio/redirect/_redirect.html',
    URL_REDIRECT_REDEFINIR_SENHA: 'https://account.activedirectory.windowsazure.com/ChangePassword.aspx',
    URL_ESQUECEU_SENHA: 'https://passwordreset.microsoftonline.com/',
    URL_EDUCADOR: 'https://educador-aura.estacioqa.net',
    URL_FAQ: '/aura-repo/estacio/faq-estudante.pdf',
    URL_MANUAL: '/aura-repo/estacio/manual-estudante.pdf',
    URL_BASE_CALENDARIO_ACADEMICO: '/aura-repo/calendario-academico/',
    EVENT_LOGIN_ENDPOINT: '/v2/eventos-login/alunos',
    CHAT_HELP: getChatHelp('estacio'),
    EXTENSOES_VALIDAS_ENVIO_ARQUIVO,
    userManagerSettings: settings,
    msalConfiguration: paraMsalConfiguration({ settings }),
    GTM_ID: 'GTM-56HT2PR',
    TAMANHO_PAGINA_RESPOSTA_TRABALHOS: 1,
    EMPREGABILIDADE,
    AJUDA_LOGIN,
    ITENS_MENU: getItensMenuConfig({ ambiente, marca }),
    ITENS_AVALIACOES: getAvaliacoesConfig({ ambiente, marca }),
    URL_CURSO_LIVRE:
      'https://online.estacio.br/?utm_source=sava&utm_medium=organic&utm_campaign=lms-estacio&utm_term=&utm_content=',
    ID_INSTITUICAO_LINKEDIN: '2848413',
    TESTE_SOCIOCOMPORTAMENTAL,
    URL_SCRIPT_CHAT_ASSISTENTE_PESSOAL: getChatScriptSource(ambiente),
    URL_ACESSO_SIRIUS_EXERCICIOS: 'https://estacio-qa.saladeavaliacoes.com.br',
    URL_ACESSO_SIRIUS_SIMULADOS: 'https://estacio-qa.saladeavaliacoes.com.br',
    URL_FICHA_CATALOGRAFICA: `https://ltechnology.com.br/gleison/`,
    SUBMENUS_DISCIPLINAS: getSubMenusDisciplinas(),
    FORMACAO_SOCIOEMOCIONAL: getFormacaoSociomeocionalConfig(),
    TAPUME_AVALIACOES: getTapumeAvaliacoesConfig(),
    TAPUME_CONFIG: getTapumeConfig({ marca }),
    NAVEGADOR_CONFIG: detectaNavegador(),
    ELEGIBILIDADE_DASHBOARD_DISCIPLINA: getElegibilidadeDashboardDisicplinaConfig({ ambiente }),
    ELEGIBILIDADE_EXIBIR_NOME_TUTOR_DISCIPLINA: getElegibilidadeExibirNomeTutorDisciplinaConfig(),
    URL_ADOBE_LAUNCH_SCRIPT:
      'https://assets.adobedtm.com/0b3049c26621/a6dfba573ee8/launch-a6935f17b378-development.min.js',
    ELEGIBILIDADE_WIDGET_AVALIACAO: getElegibilidadeWidgetAvaliacaoConfig({ ambiente }),
    ELEGIBILIDADE_SUPORTE_AOS_ESTUDOS: getElegibilidadeSuporteAosEstudosConfig({ ambiente }),
    ELEGIVEL_TAPUME_MANUTENCAO: elegivelTapumeManutencao({ marca }),
    SEGMENTACAO_OCULTAR_MENU_AVALIACOES: segmentacaoOcultarMenuAvaliacoesConfig,
    ELEGIBILIDADE_SECAO_AVALIACOES: getElegibilidadeSecaoAvaliacoes,
    ELEGIBILIDADE_ALUNO_NOVA_HOME: getElegibilidadeAlunoNovaHome({ ambiente }),
    SOURCE_CHAT_BOT_EVA: getEvaChatConfig({ ambiente, marca }),
  };
};

export default hml;
